import { render, staticRenderFns } from "./ModalDisableWebhook.vue?vue&type=template&id=6956cb96"
import script from "./ModalDisableWebhook.vue?vue&type=script&lang=js"
export * from "./ModalDisableWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports